import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up flex_box",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "select_tab_box _200" }
const _hoisted_6 = { class: "right info_box" }
const _hoisted_7 = { class: "col_blue" }
const _hoisted_8 = { class: "common_table custom_scroll" }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString($setup.state.userName) + " 회원 실적", 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "selected_tab",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.showTab = !$setup.state.showTab))
            }, [
              _createElementVNode("span", null, _toDisplayString($setup.state.nameTab), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["tab_option", [$setup.state.showTab ? 'show' : '']])
            }, [
              _createElementVNode("button", {
                type: "button",
                onClickPassive: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(1)))
              }, "성매매 의심업소 제보", 32),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab(2)))
              }, "성매매 알선광고 제보"),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeTab(3)))
              }, "반성매매 시민활동"),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changeTab(4)))
              }, "캠페인·이벤트")
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createTextVNode(" 총 ", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.totalLength)) + "건", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", null, [
          _cache[10] || (_cache[10] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { style: {"width":"80px"} }),
            _createElementVNode("col"),
            _createElementVNode("col", { style: {"width":"170px"} }),
            _createElementVNode("col", { style: {"width":"80px"} }),
            _createElementVNode("col", { style: {"width":"80px"} })
          ], -1)),
          _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "번호"),
              _createElementVNode("th", null, "제목"),
              _createElementVNode("th", null, "신청일"),
              _createElementVNode("th", null, "상태"),
              _createElementVNode("th", null, "선발여부")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            ($setup.state.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.idx
                  }, [
                    _createElementVNode("td", null, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.boardVO.title), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.getBoardStateText(item.boardVO.state)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.getApplyStateText(item.state)), 1)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("td", { colspan: "5" }, [
                    _createElementVNode("div", {
                      class: "tb_subject",
                      style: {"text-align":"center","width":"100%"}
                    }, "실적이 없습니다.")
                  ], -1)
                ]))]))
          ])
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 0,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}